// Generated by Melange

import ReportWebVitals from "./reportWebVitals";
import * as Melange__App from "./App.js";
import * as Client from "react-dom/client";
import * as JsxRuntime from "react/jsx-runtime";

import './site.css'
;

function reportWebVitals(prim) {
  ReportWebVitals();
}

const el = document.querySelector("#reason");

if (!(el == null)) {
  const root = Client.createRoot(el);
  root.render(JsxRuntime.jsx(Melange__App.make, {}));
}

ReportWebVitals();

export {
  reportWebVitals,
}
/*  Not a pure module */
